import moment from 'moment'
import { isProxy, toRaw } from 'vue'

export type TimeSeries = {[startDate: string]: {[key: string]: number}}
export type ApolloTimeSeries = {[key: string]: number | string}
export type TimeSeriesLimits = {start: string, end: string, minVal?: number, maxVal?: number}
export type TimeSeriesGraphCnf = {[key: string]: [number | string] | number | string}

export default {
  namespaced: true,
  state () {
    return {
      data: null as null | TimeSeries,
      timePlaceHolder: {} as TimeSeries,
      limits: { start: '', end: '' } as TimeSeriesLimits,
      conf: {} as TimeSeriesGraphCnf,
      sourceFormat: 'YYYY-MM-DD',
      format: 'MM/DD/YYYY'
    }
  },
  mutations: {
    add (state: any, { data, dateKey } : {data: ApolloTimeSeries[], dateKey: string}) {
      if (Object.keys(state.timePlaceHolder).length > Object.keys(state.data || {}).length) {
        let sortedData: any
        if (isProxy(state.timePlaceHolder)) {
          sortedData = structuredClone(toRaw(state.timePlaceHolder))
        } else {
          sortedData = structuredClone(state.timePlaceHolder)
        }

        data.forEach((item: ApolloTimeSeries) => {
          const key = moment(item[dateKey], state.sourceFormat).format(state.format)
          delete item[key]
          sortedData[key] = item
        })

        state.data = sortedData
      } else {
        data.forEach((item: ApolloTimeSeries) => {
          const key = moment(item[dateKey], state.sourceFormat).format(state.format)
          delete item[key]
          state.data[key] = item
        })
      }
    },
    setLimits (state: any, limits : TimeSeriesLimits) {
      state.limits = limits

      const sortedData = {} as TimeSeries
      const start = moment(limits.start, state.sourceFormat)
      const end = moment(limits.end, state.sourceFormat)

      while (start.isSameOrBefore(end)) {
        sortedData[start.format(state.format)] = {}
        start.add(1, 'day')
      }

      state.timePlaceHolder = sortedData
      state.data = null
    },
    setConf (state: any, conf: TimeSeriesGraphCnf) {
      state.conf = conf
    },
    resetStoreState (state: any) {
      state.data = null
      state.limits = { start: '', end: '' }
      state.timePlaceHolder = {}
      state.conf = {}
    }
  }
}
